angular.module('main').directive('snFieldInfo', () => {
	let template = '';

	template += '<div class="field-info">';
	template += '<h4>{{title}}</h4>';
	template += '<div class="flex-row text-break">{{message}}</div>';
	template +=
		'<div ng-show="html"><sn-quill-view-web [content]="html"></sn-quill-view-web></div> ';
	template += '</div>';

	return {
		restrict: 'AE',
		scope: {
			title: '@snTitle',
			message: '=snText',
			html: '=snHtml'
		},
		template,
		replace: true,
		link(scope, elem, attr, ctrl) {}
	};
});



// WEBPACK FOOTER //
// ./web/js/components/Filelds/snFieldInfo.js